import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useBot } from '../context/BotContext';
import { TABS } from '../constants/tabs';
import ActivityLogDrawer from './ActivityLogDrawer';

const { FiBell } = FiIcons;

export default function DesktopTopBar({ activeTab }) {
  const { activityLog, settings } = useBot();
  const [showLogs, setShowLogs] = useState(false);

  const currentTab = TABS.find(t => t.id === activeTab);
  const unreadCount = Math.min(activityLog.length, 3);

  return (
    <>
      <div className="hidden lg:flex h-10 flex-shrink-0 bg-[#1c1c1d] border-b border-[#2c2c2e] items-center px-5 gap-3 sticky top-0 z-20">
        {currentTab && (
          <>
            <SafeIcon icon={currentTab.icon} className="text-gray-400 text-sm" />
            <span className="text-white font-semibold text-sm">{currentTab.label}</span>
          </>
        )}
        <div className="flex-1" />
        {settings.tradingMode === 'live' ? (
          <span className="flex items-center gap-1 bg-green-500/20 border border-green-500/40 text-green-400 text-[9px] font-bold px-2 py-0.5 rounded uppercase tracking-wider mr-2">
            <span className="w-1.5 h-1.5 bg-green-400 rounded-full animate-pulse" />
            Live
          </span>
        ) : (
          <span className="bg-gray-500/20 border border-gray-500/30 text-gray-400 text-[9px] font-bold px-2 py-0.5 rounded uppercase tracking-wider mr-2">
            Paper
          </span>
        )}
        <button
          onClick={() => setShowLogs(true)}
          className="relative w-8 h-8 rounded-lg bg-[#2c2c2e] flex items-center justify-center text-gray-400 hover:text-white transition-colors border border-[#3c3c3e]"
        >
          <SafeIcon icon={FiBell} className="text-sm" />
          {unreadCount > 0 && (
            <span className="absolute top-0 right-0 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-[#1c1c1d]" />
          )}
        </button>
      </div>

      <ActivityLogDrawer isOpen={showLogs} onClose={() => setShowLogs(false)} activityLog={activityLog} />
    </>
  );
}
